/*
  ============================================================
  BOVEA PRODUCT ENHANCEMENTS
  Vorteile-Fade und stabiler Variantenwechsel ohne Scrollsprung.
  ============================================================
*/

(function () {
  "use strict";

  if (window.__boveaProductEnhancementsInstalled) return;
  window.__boveaProductEnhancementsInstalled = true;

  function setCollapsedHeight(shell) {
    var list = shell.querySelector("[data-bovea-benefits-list]");
    var items = shell.querySelectorAll("[data-bovea-benefit]");
    var toggle = shell.querySelector("[data-bovea-benefits-toggle]");

    if (!list || !items.length || !toggle) return;

    if (items.length <= 1) {
      shell.classList.add("has-single-benefit");
      shell.classList.remove("is-collapsed");
      shell.classList.add("is-expanded");
      toggle.setAttribute("aria-expanded", "true");
      return;
    }

    shell.classList.remove("has-single-benefit");

    var firstHeight = Math.ceil(items[0].getBoundingClientRect().height);
    var secondHeight = Math.ceil(items[1].getBoundingClientRect().height);
    var preview = Math.min(Math.max(secondHeight * 0.48, 14), 26);

    shell.style.setProperty(
      "--bovea-benefits-collapsed-height",
      firstHeight + 8 + preview + "px"
    );
  }

  function initializeBenefits(shell) {
    if (!shell || shell.dataset.boveaBenefitsReady === "true") return;

    var toggle = shell.querySelector("[data-bovea-benefits-toggle]");
    var label = shell.querySelector("[data-bovea-benefits-label]");
    if (!toggle || !label) return;

    shell.dataset.boveaBenefitsReady = "true";
    setCollapsedHeight(shell);

    toggle.addEventListener("click", function () {
      var expanded = shell.classList.contains("is-expanded");

      shell.classList.toggle("is-expanded", !expanded);
      shell.classList.toggle("is-collapsed", expanded);
      toggle.setAttribute("aria-expanded", expanded ? "false" : "true");
      label.textContent = expanded ? "Alle Vorteile anzeigen" : "Weniger anzeigen";

      if (expanded) setCollapsedHeight(shell);
    });
  }

  function initializeFaq(faq) {
    if (!faq || faq.dataset.boveaFaqReady === "true") return;

    var buttons = Array.prototype.slice.call(
      faq.querySelectorAll(".lp-product-faq__question")
    );

    if (!buttons.length) return;

    faq.dataset.boveaFaqReady = "true";

    var reducedMotion = Boolean(
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    );

    function panelFor(button) {
      var id = button.getAttribute("aria-controls");
      return id ? faq.querySelector("#" + id) : null;
    }

    function finishClose(button, panel) {
      button.setAttribute("aria-expanded", "false");
      panel.classList.remove("is-open");
      panel.hidden = true;
      panel.style.height = "0px";
    }

    function closeItem(button, immediate) {
      var panel = panelFor(button);
      if (!panel || button.getAttribute("aria-expanded") !== "true") return;

      if (immediate || reducedMotion) {
        finishClose(button, panel);
        return;
      }

      button.setAttribute("aria-expanded", "false");
      panel.style.height = panel.scrollHeight + "px";
      panel.offsetHeight;
      panel.style.height = "0px";

      var onClose = function (event) {
        if (event.propertyName !== "height") return;
        panel.removeEventListener("transitionend", onClose);
        if (button.getAttribute("aria-expanded") === "false") {
          finishClose(button, panel);
        }
      };

      panel.addEventListener("transitionend", onClose);
    }

    function openItem(button) {
      var panel = panelFor(button);
      if (!panel) return;

      buttons.forEach(function (otherButton) {
        if (otherButton !== button) closeItem(otherButton, false);
      });

      button.setAttribute("aria-expanded", "true");
      panel.hidden = false;
      panel.classList.add("is-open");

      if (reducedMotion) {
        panel.style.height = "auto";
        return;
      }

      panel.style.height = "0px";
      panel.offsetHeight;
      panel.style.height = panel.scrollHeight + "px";

      var onOpen = function (event) {
        if (event.propertyName !== "height") return;
        panel.removeEventListener("transitionend", onOpen);
        if (button.getAttribute("aria-expanded") === "true") {
          panel.style.height = "auto";
        }
      };

      panel.addEventListener("transitionend", onOpen);
    }

    buttons.forEach(function (button) {
      var panel = panelFor(button);
      button.setAttribute("aria-expanded", "false");

      if (panel) {
        panel.hidden = true;
        panel.style.height = "0px";
      }

      button.addEventListener("click", function () {
        if (button.getAttribute("aria-expanded") === "true") {
          closeItem(button, false);
        } else {
          openItem(button);
        }
      });
    });
  }

  function preserveScrollPosition(section) {
    if (!section || section.dataset.boveaStableVariants === "true") return;
    section.dataset.boveaStableVariants = "true";

    var savedY = 0;
    var restoreUntil = 0;
    var restoring = false;

    function remember() {
      savedY = window.pageYOffset || document.documentElement.scrollTop || 0;
      restoreUntil = Date.now() + 700;
    }

    function restore() {
      if (restoring || Date.now() > restoreUntil) return;
      restoring = true;
      window.requestAnimationFrame(function () {
        window.scrollTo(0, savedY);
        window.requestAnimationFrame(function () {
          window.scrollTo(0, savedY);
          restoring = false;
        });
      });
    }

    section.addEventListener("pointerdown", function (event) {
      if (event.target.closest(".lp-variant-pill, [data-lp-set-card]")) remember();
    }, true);

    section.addEventListener("click", function (event) {
      if (!event.target.closest(".lp-variant-pill, [data-lp-set-card]")) return;
      remember();
      restore();
      window.setTimeout(restore, 40);
      window.setTimeout(restore, 120);
      window.setTimeout(restore, 280);
      window.setTimeout(restore, 520);
    }, true);

    section.addEventListener("change", function (event) {
      if (!event.target.matches(".lp-variant-input, [data-lumino-option]")) return;
      restore();
      window.setTimeout(restore, 40);
      window.setTimeout(restore, 150);
      window.setTimeout(restore, 350);
    }, true);
  }

  function initialize(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll("[data-bovea-benefits]").forEach(initializeBenefits);
    scope.querySelectorAll("[data-bovea-product-faq]").forEach(initializeFaq);
    scope.querySelectorAll('[id^="LuminoProductNord_"]').forEach(preserveScrollPosition);
  }

  function start() {
    initialize(document);

    var resizeTimer = null;
    window.addEventListener("resize", function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        document.querySelectorAll("[data-bovea-benefits]").forEach(setCollapsedHeight);
      }, 120);
    });
  }

  document.addEventListener("shopify:section:load", function (event) {
    initialize(event.target || document);
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();
